import React from "react";
import { Spin } from "antd";
import PropTypes from "prop-types";
import DocumentService from "services/documents-service";

class DocumentViewer extends React.PureComponent {

    state = {
        loading: true,
        url: null,
        fileType: null
    };

    componentDidUpdate(prevProps) {
        if(this.props.url && prevProps.url !== this.props.url) {
            this.fetchDocument(this.props.url);
        }
    }

    componentDidMount() {
        if(this.props.url) {
            this.fetchDocument(this.props.url);
        }
    }

    fetchDocument(url) {
        if(this.props.isInvoice) {
            this.setState({
                fileType: "application/pdf",
                loading: false
            }, () => {
                var file_elem = window.document.getElementById("file-viewer");
                file_elem.src = url;
            });
        }
        else {
            DocumentService.getDocumentUrl(url, this.props.isInvoice).then(({data, headers}) => {
                this.setState({
                    loading: false,
                    fileType: headers["content-type"]
                }, () => {
                    const file = new Blob([data], {type: headers["content-type"]});
                    if(headers["content-type"] && headers["content-type"].includes("pdf")) {
                        var elem = window.document.getElementById("file-viewer");
                        elem.src = URL.createObjectURL(file);
                    } else {
                        if(window.document.getElementById("image-viewer")){
                            var image_elem = window.document.getElementById("image-viewer");
                            image_elem.src = URL.createObjectURL(file);    
                        }
                    }
                });
            }).catch((err) => {
                console.error("---> ", err);
            });
        }
    }

    render() {
        const { width, height } = this.props;
        if(!this.props.url && this.props.loading){
            return <img id={"image-viewer"} width={0}/>
        }
        if(this.state.fileType && this.state.fileType.includes("pdf")) {
            return (
                <React.Fragment>
                    <Spin spinning={this.state.loading}>
                        <iframe id={"file-viewer"} width={width} height={height} sandbox={false} />
                    </Spin>
                </React.Fragment>
            );
        }
        return (
            <React.Fragment>
                <Spin spinning={this.state.loading}>
                    <img id={"image-viewer"} width={width}/>
                </Spin>
            </React.Fragment>
        );
    }
}

DocumentViewer.propTypes = {
    url: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    companyId: PropTypes.number,
    documentName: PropTypes.string,
    isInvoice: PropTypes.bool,
    loading: PropTypes.bool
};

DocumentViewer.defaultProps = {
    width: 1000,
    height: 1000,
    isInvoice: false,
    loading : false
};

export default DocumentViewer;
